import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { currencyString } from "@qgiv/core-js";
import { getFormattedPrice } from "@qgiv/core-donor";
import { hasActiveProductsToBeDisplayed } from "@qgiv/p2p-registration";
import { ThemeType } from "../../../redux/constants";
import { selectReceipt } from "../../../redux/slices/receiptSlice";
import { selectAllP2pSettings } from "../../../redux/slices/p2pSettingsSlice";
import { selectAllFormSettings } from "../../../redux/slices/formSettingsSlice";
import { selectThemeSettings } from "../../../redux/slices/cmsSettingsSlice";
import { selectIsCms } from "../../../redux/slices/configSlice";
import { selectTaxRate } from "../../../redux/slices/productSettingsSlice";
import { selectAllProducts } from "../../../redux/slices/productsSlice";
import ReceiptDetailsStore from "./ReceiptDetailsStore";

const ConnectedReceiptDetailsStore = ({ controlId }) => {
    const isCms = useSelector(selectIsCms);
    const themeSettings = useSelector((state) =>
        selectThemeSettings(ThemeType.SUMMARY, state),
    );
    const {
        p2pGeneral: { subtotalLabel = "Subtotal" },

        p2pStore: {
            storeSubsectionHeading = "Add-ons",
            shippingLabel = "Shipping",
            taxLabel = "Tax",
        },
    } = themeSettings;

    const receipt = useSelector(selectReceipt);

    const taxRate = useSelector(selectTaxRate);
    const products = useSelector(selectAllProducts);
    const p2pSettings = useSelector(selectAllP2pSettings);

    const { registrationFeeDisplay, registrationFeeDisplayText } = p2pSettings;

    const {
        transaction: { store = [] },
    } = receipt;
    const isStoreVisibleOnCms =
        isCms && Object.keys(store).length > 0
            ? hasActiveProductsToBeDisplayed(products)
            : false;
    const {
        totalTaxAmount = 0.0,
        shippingMethodCost = 0.0,
        totalCost = 0,
        cart = [],
        shippingMethodDescription = "",
        shippingMethodName = "",
    } = store;

    const formSettings = useSelector(selectAllFormSettings);
    const { currency } = formSettings;

    const formattedTaxAmount = totalTaxAmount
        ? currencyString(totalTaxAmount, currency)
        : "";
    const formattedShippingAmount = getFormattedPrice(
        shippingMethodCost,
        currency,
        registrationFeeDisplay,
        registrationFeeDisplayText,
    );

    const formattedStoreTotal = totalCost
        ? currencyString(Number(totalCost), currency)
        : "";

    const hasShippingMethod = !!(
        shippingMethodName && shippingMethodName.length > 0
    );
    const isVisible =
        (!isCms && (totalCost > 0 || cart.length > 0)) || isStoreVisibleOnCms;

    const receiptDetailsStoreProps = {
        controlId,
        formattedShippingAmount,
        formattedStoreTotal,
        formattedTaxAmount,
        hasShippingMethod,
        isVisible,
        taxRate,
        totalCost,
        cart,
        shippingMethodDescription,
        shippingMethodName,
        // Theme Settings Labels
        subtotalLabel,
        storeSubsectionHeading,
        shippingLabel,
        taxLabel,
    };

    return <ReceiptDetailsStore {...receiptDetailsStoreProps} />;
};

ConnectedReceiptDetailsStore.propTypes = {
    controlId: PropTypes.number.isRequired,
};

export default ConnectedReceiptDetailsStore;
